<template>
  <OperativeTableBodyRowKpi class="operative-table-body-kpi-row" :values="values" :strong="strong" :scale="scale" :hide-label="hideLabel" :align="align" :showValues="showValues">
    <template #default><slot></slot></template>
  </OperativeTableBodyRowKpi>
</template>

<script>

export default {
  name: 'operative-table-body-row-kpi-rating',
  components: {
    OperativeTableBodyRowKpi: () => import('./OperativeTableBodyRowKpi'),
  },
  props: {
    values: {
      type: Array,
      default: () => [],
    },
    strong: {
      type: Boolean,
      default: false,
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    align: {
      type: String,
      default: 'default',
    },
    showValues: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      scale: {
        1: { label: 'D', rank: 1 },
        2: { label: 'D+', rank: 1 },
        3: { label: 'C', rank: 2 },
        4: { label: 'C+', rank: 2 },
        5: { label: 'B', rank: 3 },
        6: { label: 'B+', rank: 3 },
        7: { label: 'A', rank: 4 },
        8: { label: 'A+', rank: 5 },
      },
    };
  },
};

</script>
